const nbNO= {
    login: {
      title: 'Logg på',
      sign_in_btn: 'Logg på'
    },
    bar: {
        logout: 'Logg av',
        languages: 'Språk',
        settings: 'Åpne innstillinger'
    },
    language: {
      name: 'Norsk (Norge)',
    },
    attributePage: {
        title: 'Endringer i attributter',
        viewChanges: 'Se endringer',
        dateTime: 'Dato',
        notificationType: 'Type varsel',
        notificationValue: 'Varslingsverdi',
        oldValue: 'Gammel verdi',
        newValue: 'Ny verdi',
        accept: 'Aksepter',
        reject: 'Avslå',
    },
    Home: 'Hjem',
    load: 'Utfører innledende lasting ...',
    Requested: "Forespurt",
    Viewed: "Sett",
    Executing: "Utført",
    Completed: "Fullført",
    Expired: "Utløpt",
    Cancelled: "Avbrutt",
    Error: "Feil",
    Rejected: "Avslått",
    error: 'Noe gikk galt. Prøv igjen senere.',
    displayname: 'Visningsnavn',
    givenname: 'Fornavn',
    surname: 'Etternavn',
    email: 'E-postadresse',
    mail: 'E-postadresse',
    name: 'Fornavn',
    firstname: 'Fornavn',
    lastname: 'Etternavn',
    footer_copyright: 'Med enerett.'
  };
  
  export default nbNO;
  